import { useState, useEffect, useRef } from 'react';
import { DeclarationDocumentsTableContent } from './DeclarationDocumentsTableContent';
import { getDeclarationSummaryTranslation } from '../../../hooks/useLanguage';
import { deepClone } from '../../../utils/dataHelpers';
import { createPartidasDocumentosSignature } from '../../../utils/declarationSummaryUtils';

export const DeclarationDocumentsTable = ({
  declarationIndex,
  isSpanish,
  declaration,
  editableData,
  setEditableData,
  setIsDirty,
}) => {
  const [openDocModalIndex, setOpenDocModalIndex] = useState(null);
  const [openTipoModal, setOpenTipoModal] = useState({});
  const prevPartidasSignatureRef = useRef(null);

  // Auto-aggregate documentos from partidas if empty - optimized with signature comparison
  useEffect(() => {
    if (!declaration || !declaration.partidas) return;
    
    const hasDocumentos = declaration.documentos && Array.isArray(declaration.documentos) && declaration.documentos.length > 0;
    if (hasDocumentos) {
      return;
    }
    
    const currentSignature = createPartidasDocumentosSignature(declaration);
    const prevSignature = prevPartidasSignatureRef.current;
    
    if (prevSignature === currentSignature) {
      return;
    }
    
    prevPartidasSignatureRef.current = currentSignature;
    
      const allDocumentos = [];
      declaration.partidas.forEach((partida) => {
        if (partida.documentos && Array.isArray(partida.documentos)) {
          partida.documentos.forEach((doc) => {
            if (doc && typeof doc === 'object') {
            allDocumentos.push({ ...doc });
            }
          });
        }
      });
      
      if (allDocumentos.length > 0) {
        const updatedData = deepClone(editableData);
        updatedData[declarationIndex].documentos = allDocumentos;
        setEditableData(updatedData);
        setIsDirty(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [declaration?.partidas]);

  // Get documentos to display (either from declaration or aggregated)
  const documentosToDisplay = declaration.documentos && Array.isArray(declaration.documentos) && declaration.documentos.length > 0
    ? declaration.documentos
    : (() => {
        if (!declaration.partidas) return [];
        const allDocumentos = [];
        declaration.partidas.forEach((partida) => {
          if (partida.documentos && Array.isArray(partida.documentos)) {
            partida.documentos.forEach((doc) => {
              if (doc && typeof doc === 'object') {
                allDocumentos.push({ ...doc });
              }
            });
          }
        });
        return allDocumentos;
      })();

  if (!documentosToDisplay || documentosToDisplay.length === 0) {
    return null;
  }

  return (
    <div className="document-table mt-6">
      <div className="form-group flex-1 mt-12 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 !text-xl font-semibold uppercase">
          {!isSpanish ? "Export Level Documents" : "Documentos Nivel Exportación"} (
          {documentosToDisplay.length})
        </label>
      </div>
      <DeclarationDocumentsTableContent
        declarationIndex={declarationIndex}
        isSpanish={isSpanish}
        declaration={{ ...declaration, documentos: documentosToDisplay }}
        editableData={editableData}
        setEditableData={setEditableData}
        setIsDirty={setIsDirty}
        openDocModalIndex={openDocModalIndex}
        setOpenDocModalIndex={setOpenDocModalIndex}
        openTipoModal={openTipoModal}
        setOpenTipoModal={setOpenTipoModal}
      />
    </div>
  );
};

